import React, {Component, PropTypes} from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import cx from 'classnames'
import {Row, Col, ButtonGroup, Button, Tooltip, OverlayTrigger} from 'react-bootstrap'
import chartistLegend from 'chartist-plugin-legend'
import extract from '../../core/extract'
import {uiState, setUIState} from '../../core/redux/ui'
import Icon from '../../core/components/Icon'
import DownloadIcon from '../../core/components/DownloadIcon'
import Chart, {totalAngle} from '../../core/components/Chart'
import ButtonToggle from '../../core/components/ButtonToggle'
import {XLSX_TICKETS_EXPORTED, PDF_TICKETS_EXPORTED, PDF_TICKETS_REPORTED} from '../actions'
import i18n from '../i18n'
import ExportTicketsModal from './ExportTicketsModal'
import style from './TicketStats.less'

const COMPONENT_NAME = 'Ticket/TicketStats'

class TicketStats extends Component {
    static propTypes = {
        stacked: PropTypes.bool
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _toggle(event) {
        const {dispatch, ui} = this.props
        const {closed} = uiState(COMPONENT_NAME, ui)

        event.preventDefault()
        dispatch(setUIState(COMPONENT_NAME, {closed: !closed}))
    }

    _openModal(name) {
        this.setState({openedModal: name})
    }

    _closeModal() {
        this.setState({openedModal: null})
    }

    render() {
        const {dispatch, location, aggregations, stats, range, ui, progress, stacked} = this.props
        const {openedModal} = this.state
        const {closed} = uiState(COMPONENT_NAME, ui)

        const transitionName = {
            enter: style.enter,
            enterActive: style.enterActive,
            leave: style.leave,
            leaveActive: style.leaveActive
        }

        const statusChartTotal = totalAngle({
            source: aggregations.status,
            angle: 220,
            identify: (s) => s.count
        })

        const statusChartPlugins = [
            chartistLegend({
                legendNames: aggregations.status.map((s) => extract(i18n.ticketsDashboardStatusEnum, s.value))
            })
        ]

        const interventionChartTotal = totalAngle({
            source: aggregations.interventions,
            angle: 220,
            identify: (i) => i.count
        })

        const interventionChartPlugins = [
            chartistLegend({
                legendNames: aggregations.interventions.map((i) => extract(i18n.ticketsInterventionEnum, i.value))
            })
        ]

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        return (
            <div className={cx(style.default, {[style.stacked]: stacked})}>
                <Row>
                    {!stacked && (
                        <Col sm={4} smOffset={4} xsHidden>
                            <a
                                href=''
                                onClick={(e) => this._toggle(e)}>
                                <h3>
                                    <span>{i18n.summary}</span>
                                    <Icon
                                        icon={closed && 'down' || 'up'}
                                        size='xs' />
                                </h3>
                            </a>
                        </Col>
                    )}
                    <Col
                        sm={stacked && 12 || 4}>
                        <div className={style.switch}>
                            <div className={style.export}>
                                <OverlayTrigger
                                    placement='bottom'
                                    overlay={tooltip(progress[XLSX_TICKETS_EXPORTED] && i18n.exportingTickets || i18n.exportTickets)}>
                                    <Button
                                        bsStyle='link'
                                        bsSize='small'
                                        disabled={!!progress[XLSX_TICKETS_EXPORTED]}
                                        onClick={() => this._openModal('ExportTicketsModal')}>
                                        <DownloadIcon progress={progress[XLSX_TICKETS_EXPORTED] || progress[PDF_TICKETS_EXPORTED] || progress[PDF_TICKETS_REPORTED]} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                            <div className={style.container}>
                                <ButtonToggle
                                    value={location.pathname}
                                    onChange={(p) => p && dispatch(push(p))}>
                                    <ButtonGroup>
                                        <Button
                                            bsSize='small'
                                            value='/tickets'>
                                            {i18n.search}
                                        </Button>
                                        <Button
                                            bsSize='small'
                                            value='/tickets/dashboard'>
                                            {i18n.stats}
                                        </Button>
                                    </ButtonGroup>
                                </ButtonToggle>
                            </div>
                        </div>
                    </Col>
                </Row>
                <ReactCSSTransitionGroup
                    transitionName={transitionName}
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={500}>
                    {(!closed || stacked) && (
                        <div className={style.body}>
                            <Row>
                                <Col sm={stacked && 12 || 4}>
                                    <div className={style.newTickets}>
                                        <h4>{range.count} {i18n.newTickets}</h4>
                                        <div className={style.count}>
                                            <span>{stats.newTickets.lastSevenDays}</span>
                                            <small>{i18n.lastWeek}</small>
                                        </div>
                                        <div className={style.count}>
                                            <span>{stats.newTickets.currentMonth}</span>
                                            <small>{i18n.thisMonth}</small>
                                        </div>
                                        <div className={style.count}>
                                            <span>{stats.newTickets.lastMonth}</span>
                                            <small>{i18n.lastMonth}</small>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={stacked && 12 || 4}>
                                    <div className={style.distribution}>
                                        <h4>{i18n.ticketsDistribution}</h4>
                                        <div className={style.chart}>
                                            <Chart donut
                                                kind='Pie'
                                                ratio='square'
                                                donutWidth={60}
                                                startAngle={250}
                                                total={statusChartTotal}
                                                plugins={statusChartPlugins}
                                                display={(m) => m.count}
                                                identify={(m) => m.count}
                                                value={aggregations.status} />
                                        </div>
                                        <div className={style.chart}>
                                            <Chart donut inverse
                                                kind='Pie'
                                                ratio='square'
                                                donutWidth={60}
                                                startAngle={250}
                                                total={interventionChartTotal}
                                                plugins={interventionChartPlugins}
                                                display={(m) => m.count}
                                                identify={(m) => m.count}
                                                value={aggregations.interventions} />
                                        </div>
                                    </div>
                                </Col>
                                {!stacked && (
                                    <Col sm={4}>
                                        <div className={style.creationFrequency}>
                                            <h4>
                                                {i18n.ticketsCreationFrequency}
                                                <small>{i18n.dailyCreatedTicketCount}</small>
                                            </h4>
                                            <div className={style.count}>
                                                <span>{stats.ticketCreationFrequency.byDay}</span>
                                                <Icon icon='file' size='xl' />
                                            </div>
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )}
                </ReactCSSTransitionGroup>
                <ExportTicketsModal
                    show={openedModal == 'ExportTicketsModal'}
                    onHide={() => this._closeModal()} />
            </div>
        )
    }
}

TicketStats = connect((state) => ({
    location: state.router.location,
    ui: state.ui,
    progress: state.progress,
    aggregations: state.ticket.aggregations,
    stats: state.ticket.stats,
    range: state.ticket.range
}))(TicketStats)

export default TicketStats


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketStats.js